import axios from "axios";
import Config from "../../config";
import { HmacSignatureUtilities } from "../../services/hmac-encryption-decryption";
import { getClientInfoAxiosHeaders } from "../../services/ClientInfoService";


const urlParams = new URLSearchParams(window.location.search);
const participantId = urlParams.get('id');

const SecureChatInstance = axios.create();

// Attach client-info headers + token to every request
SecureChatInstance.interceptors.request.use((config) => {
  Object.assign(config.headers, getClientInfoAxiosHeaders());
  const token = localStorage.getItem(`${participantId}-accessToken`);
  if (token) config.headers.Authorization = `Bearer ${token}`;
  if (config.data && Object.keys(config.data).length > 0) {
    config.headers.FalkonSignature = HmacSignatureUtilities.signData(config.data)
  }
  return config;
});

// Refresh token on 401 errors
SecureChatInstance.interceptors.response.use(
  (res) => res,
  async (err) => {
    const originalRequest = err.config;

    if (err.response?.status === 401 && !originalRequest._retry) {
      originalRequest._retry = true;

      try {
        const refreshToken = localStorage.getItem(`${participantId}-refreshToken`);
        const res = await axios.post(`${Config.API_SECOND_URL}/falkon/notify/api/v1/secureChat/refresh-token`, {
          refresh_token:refreshToken,
        });

        const newAccessToken = res.data.access_token;
        localStorage.setItem(`${participantId}-accessToken`, newAccessToken);

        // Retry the failed request with the new token
        originalRequest.headers.Authorization = `Bearer ${newAccessToken}`;
        return SecureChatInstance(originalRequest);
      } catch (refreshErr) {
        // Refresh failed, log out user
        localStorage.clear();
        return Promise.reject(refreshErr);
      }
    }
    return Promise.reject(err);
  }
);

export default SecureChatInstance;
